export default class {
  nom = ""
  prenom = ""
  courriel = ""
  numeroTelephone = ""
  numeroPermis = ""
  message = ""
  sujet = ""
  objetDeLaDemande = ""
  disponibilites = ""
  consentement = false
  demandeCopie = false
}